import React, { useState } from "react";
import AddSectionModal from "./AddSectionModal";
import { getImageUrl } from "../../../commons/assets_path";
import axios from "axios";
import useLanguageChange from "../../../hooks/useLanguageChange";
type Props = {
  clientCode: string;
  sectionName: string;
  sectionId: string;
  locale: string;
};

const EditSectionButton = ({ clientCode, sectionName, sectionId, locale }: Props) => {
  const { t } = useLanguageChange(locale);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>("");

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleUpdate = async (newName: string) => {
    const response = await axios.patch(`/${clientCode}/sections/${sectionId}`, {
      section: { name: newName },
    });
    if (response.status === 200) {
      window.location.href = response.data.url;
    } else {
      setErrorMessage(t("EditSectionButton.プロジェクトの編集に失敗しました"));
    }
  };

  return (
    <>
      <div
        onClick={openModal}
        className="dropdown-item-wrap"
        style={{ cursor: "pointer" }}
        data-testid="edit-section-button"
      >
        <div className="dropdown-item px-2">
          <img
            src={getImageUrl("images/icons/editBlack.svg")}
            className="mr-1 mb-1"
            width="20"
            height="20"
            alt={t("EditSectionButton.セクション編集")}
          />
          {t("EditSectionButton.編集する")}
        </div>
      </div>
      <AddSectionModal
        isOpen={isModalOpen}
        onClose={closeModal}
        name={sectionName}
        onSubmit={handleUpdate}
        errorMessage={errorMessage}
        isEdit={true}
      />
    </>
  );
};

export default EditSectionButton;
